import "./digital-assets-sections-list.scss";

export class DigitalAssetsSectionsList {
  #listSelector;

  #activeItemSelector;

  constructor(props) {
    this.#listSelector = props.listSelector;
    this.#activeItemSelector = props.activeItemSelector;

    this.scrollToActiveElement();
  }

  get #activeItem() {
    return document.querySelector(`${this.#listSelector} ${this.#activeItemSelector}`);
  }

  scrollToActiveElement() {
    this.#activeItem?.scrollIntoView({
      block: "center",
      behavior: "smooth"
    });
  }
}

export default () =>
  new DigitalAssetsSectionsList({
    listSelector: ".js-digital-assets-sections-list",
    activeItemSelector: ".active"
  });
